import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth'
import { initializeFirestore, collection, collectionGroup, getDocs, doc, getDoc, query, where, orderBy, limit, writeBatch, addDoc, setDoc, deleteDoc, updateDoc, documentId } from "firebase/firestore"
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage'
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"

// Your web app's Firebase configuration
let firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app)
const auth = getAuth(app)
const firestore = initializeFirestore(app, {ignoreUndefinedProperties: true}, process.env.VUE_APP_DATABASE_NAME || '(default)')
const storage = getStorage(app)
self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.NODE_ENV !== 'production'
initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.VUE_APP_RECAPTCHA_SITE_KEY),

    // Optional argument. If true, the SDK automatically refreshes App Check
    // tokens as needed.
    isTokenAutoRefreshEnabled: true
})

const fb = {
    app,
    analytics,
    auth,
    signInWithEmailAndPassword,
    onAuthStateChanged,
    firestore,
    collection,
    collectionGroup,
    getDocs,
    doc,
    getDoc,
    query,
    where,
    orderBy,
    limit,
    writeBatch,
    addDoc,
    setDoc,
    deleteDoc,
    updateDoc,
    documentId,
    storage,
    ref,
    uploadBytesResumable,
    getDownloadURL,
    deleteObject,
}

export default fb
